import { Avatar, Box, Button, Group, Stack, Title } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Board } from "../../common/boards/board.schema";
import { Event } from "../../common/events/event.schema";

import PrintFooter from "../print/PrintFooter";
import SeedTable from "./SeedTable";

const PrintSeedTable = ({
  disabled,
  event,
  board,
  debug,
}: {
  disabled?: boolean;
  debug?: boolean;
  event: Event;
  board: Board;
}) => {
  const componentRef = useRef<any>();
  // console.log("activeMembers :", activeMembers);

  // console.log("displayRows :", displayRows);

  // return <></>;
  const image = event.image || board.image;
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button
            leftSection={<IconPrinter size={15} />}
            variant="subtle"
            disabled={disabled}
            size="xs"
          >
            Print seeds
          </Button>
        )}
        content={() => componentRef.current || null}
      />
      <div style={{ display: debug ? "block" : "none" }}>
        <Stack
          align="center"
          ref={componentRef}
          style={{ backgroundColor: "white", color: "black" }}
          py={20}
          px={20}
        >
          <Stack align="center">
            <Group>
              {image && <Avatar src={image} />}
              <Title ta="center">{board.name}</Title>
            </Group>
            <Title order={2} ta="center">
              {event.name}
            </Title>
            <Title order={3} ta="center">
              Seeds
            </Title>
          </Stack>
          <Box w="100%">
            <SeedTable event={event} />
          </Box>
          <PrintFooter />
        </Stack>
      </div>
    </>
  );
};
export default PrintSeedTable;
